import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-overview-contract-summary',
  templateUrl: './overview-contract-summary.component.html',
  styleUrls: ['./overview-contract-summary.component.scss'],
})
export class OverviewContractSummaryComponent implements OnInit {

  @Input() contractSummary: any;
  @Input() showGeneralFaqs = false;

  generalFaqsDocs: any[] = [];
  specificFaqsDocs: any[] = [];
  contractDocs: any[] = [];

  hasSection = false;
  sectionInfo: any;
  viewMore = false;
  viewMoreBlur = false;

  constructor(private translate: TranslateService, private chdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.buildDocuments(this.translate.currentLang);
    this.translate.onLangChange.subscribe(event => {
      this.buildDocuments(event.lang);
      this.chdRef.detectChanges();
    });
  }

  private isNewFormat(locale: any): boolean {
    return locale && !Array.isArray(locale) && typeof locale === 'object';
  }

  private buildDocuments(currentLang: string) {
    this.generalFaqsDocs = [];
    this.specificFaqsDocs = [];
    this.contractDocs = [];
    this.hasSection = false;
    this.sectionInfo = null;

    this.buildGeneralFaqs();

    if (this.isNewFormat(this.contractSummary)) {
      this.buildFromNewFormat(currentLang);
    } else {
      this.buildFromOldFormat(currentLang);
    }
  }

  private buildGeneralFaqs() {
    if (!this.showGeneralFaqs) return;
    const htmlString = this.translate.instant('OVERVIEW.GENERIC_RESERVATION_FAQS');
    if (!htmlString || htmlString === 'OVERVIEW.GENERIC_RESERVATION_FAQS') return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const h1List = doc.getElementsByTagName('h1');
    const divList = doc.getElementsByTagName('div');

    for (let i = 0; i < h1List.length; i++) {
      this.generalFaqsDocs.push({
        index: i,
        opened: false,
        title: h1List[i].innerHTML,
        content: divList[i]?.innerHTML || '',
        idContent: `gen_content${i}`
      });
    }
  }

  private buildFromNewFormat(currentLang: string) {
    const langData = this.contractSummary[currentLang] || this.contractSummary['es'];
    if (!langData) return;

    if (langData?.contract_summary?.length) {
      const items = [...langData.contract_summary].sort((a, b) => a.sortOrder - b.sortOrder);
      this.contractDocs = items.map((item, index) => ({
        index,
        opened: false,
        title: item.title,
        content: item.content,
        idContent: `cont_content${index}`
      }));
    }

    if (langData?.faq?.length) {
      const items = [...langData.faq].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
      this.specificFaqsDocs = items.map((item, index) => ({
        index,
        opened: false,
        title: item.title,
        content: item.content,
        idContent: `spec_content${index}`
      }));
    }
  }

  private buildFromOldFormat(currentLang: string) {
    let fullSummary;
    for (let i = 0; i < this.contractSummary.length; i++) {
      if (this.contractSummary[i].contract_summary !== null
        && this.contractSummary[i].contract_summary !== undefined
        && currentLang === this.contractSummary[i].language) {
          fullSummary = this.contractSummary[i].contract_summary;
        } else {
          if (this.contractSummary[i].contract_summary === undefined && currentLang === this.contractSummary[i].language) {
            for (let j = 0; j < this.contractSummary.length; j++) {
              if (this.contractSummary[j].language === 'es') {
                fullSummary = this.contractSummary[j].contract_summary;
              }
            }
          }
        }
    }

    if (!fullSummary) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(fullSummary, 'text/html');
    const h1List = doc.getElementsByTagName('h1');
    const divList = doc.getElementsByTagName('div');
    const sectionList = doc.getElementsByTagName('section');

    for (let i = 0; i < h1List.length; i++) {
      this.contractDocs.push({
        index: i,
        opened: false,
        title: h1List[i].innerHTML,
        content: divList[i].innerHTML,
        idContent: `cont_content${i}`
      });
    }

    if (sectionList !== null && sectionList !== undefined) {
      this.hasSection = sectionList.length > 0;
      if (this.hasSection) {
        this.sectionInfo = sectionList[0].innerHTML;
      }
    }
  }

  openItem(element: any) {
    element.opened = !element.opened;
    const el = document.getElementById(element.idContent);
    if (!el) return;
    if (element.opened) {
      el.style.height = `${el.scrollHeight}px`;
      el.style.transition = 'height 0.5s';
    } else {
      el.style.height = '0px';
      el.style.transition = 'height 0.5s';
    }
  }

  toggleSection() {
    this.viewMore = !this.viewMore;
    const el = document.getElementById('sectionInfo');
    if (!el) return;
    if (this.viewMore) {
      el.style.height = `${el.scrollHeight}px`;
      el.style.transition = 'height 0.5s';
      this.viewMoreBlur = true;
    } else {
      el.style.height = '68px';
      el.style.transition = 'height 0.5s';
      setTimeout(() => {
        this.viewMoreBlur = false;
      }, 500);
    }
  }

}